//@ts-nocheck
import  { useEffect, useState } from 'react';
import { 
  GripVertical, 
  Plus, 
  Minus, 
  
  RotateCcw, 
  Info, 
  Sparkles, 
  
  Search, 

  CheckCircle2, 
  X,
  AlertTriangle,
  ChevronLeft,
  ChevronRight,
 
} from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useConfirmQualifiedTeamsMutation, useGetQualifiedTeamsQuery } from '../../lib/redux/services/sections/Leagues-Tournaments';
import Button from '../../components/global/Button';
import { toast } from 'react-toastify';
import { cn, toastMessage } from '../../utils/utils';

type props = {
  pageType?: "tournament" | "league";
};

export default function RunnerUp({pageType}:props) {
    const { id } = useParams();
    const navigate = useNavigate();
  const [qualifierPerGroup, setQualifierPerGroup] = useState(3);
  const [finalQualifier, setFinalQualifier] = useState(16);
  const [requiredCount, setRequiredCount] = useState(8);
  const [qualifiedTeams, setQualifiedTeams] = useState([]);
  const [remainingTeams, setRemainingTeams] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [draggedTeam, setDraggedTeam] = useState(null);
  const [dragSource, setDragSource] = useState(null); // 'qualified' | 'remaining'
  const [searchQuery, setSearchQuery] = useState('');
  const [notification, setNotification] = useState(null);
  const [confirmQualifiedTeams] = useConfirmQualifiedTeamsMutation();
  const { data: qualifiedTeamsData, isFetching: isFetchingQualifiedTeams } = useGetQualifiedTeamsQuery({
    event_id: id,
    booking_type: pageType,
  });
  useEffect(() => {
    if (qualifiedTeamsData) {
        console.log(qualifiedTeamsData.data);
        
      setQualifiedTeams(qualifiedTeamsData.data.auto_qualified_teams);
      setRemainingTeams(qualifiedTeamsData.data.remaining_teams);
      setQualifierPerGroup(qualifiedTeamsData.data.min_advancing_per_group);
      setFinalQualifier(qualifiedTeamsData.data.total_advancing_teams);
      setRequiredCount(qualifiedTeamsData.data.total_advancing_teams);

    }
  }, [qualifiedTeamsData]);
  const showToast = (message, type = 'info') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleDragStart = (e, team, source) => {
    setDraggedTeam(team);
    setDragSource(source);
    e.dataTransfer.setData('text/plain', team.id);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDropToQualified = (e, targetIndex = null) => {
    e.preventDefault();
    if (!draggedTeam) return;

    if (dragSource === 'remaining') {
      if (qualifiedTeams.length >= requiredCount) {
        showToast(`Bracket limit reached (${requiredCount} teams max)! Remove a team first.`, 'warning');
        return;
      }
      // Add team to qualified, remove from remaining
      setRemainingTeams(remainingTeams.filter((t) => t.id !== draggedTeam.id));
      if (targetIndex !== null) {
        const newQual = [...qualifiedTeams];
        newQual.splice(targetIndex, 0, draggedTeam);
        setQualifiedTeams(newQual);
      } else {
        setQualifiedTeams([...qualifiedTeams, draggedTeam]);
      }
      showToast(`${draggedTeam.name} moved to Qualified Teams!`, 'success');
    } else if (dragSource === 'qualified' && targetIndex !== null) {
      // Reorder within qualified
      const filtered = qualifiedTeams.filter((t) => t.id !== draggedTeam.id);
      filtered.splice(targetIndex, 0, draggedTeam);
      setQualifiedTeams(filtered);
    }
    setDraggedTeam(null);
    setDragSource(null);
  };

  const handleDropToRemaining = (e) => {
    e.preventDefault();
    if (!draggedTeam) return;

    if (dragSource === 'qualified') {
      setQualifiedTeams(qualifiedTeams.filter((t) => t.id !== draggedTeam.id));
      setRemainingTeams([draggedTeam, ...remainingTeams]);
      showToast(`${draggedTeam.name} moved back to Remaining Teams.`, 'info');
    }
    setDraggedTeam(null);
    setDragSource(null);
  };

  const moveToQualified = (team) => {
    if (qualifiedTeams.length >= requiredCount) {
      showToast(`Bracket limit reached (${requiredCount} max)!`, 'warning');
      return;
    }
    setRemainingTeams(remainingTeams.filter((t) => t.id !== team.id));
    setQualifiedTeams([...qualifiedTeams, team]);
    showToast(`${team.name} added to Qualified Teams!`, 'success');
  };

  const removeFromQualified = (team) => {
    setQualifiedTeams(qualifiedTeams.filter((t) => t.id !== team.id));
    setRemainingTeams([team, ...remainingTeams]);
    showToast(`${team.name} moved to Remaining Teams.`, 'info');
  };

  const autoFillRecommended = () => {
    const spaceNeeded = requiredCount - qualifiedTeams.length;
    if (spaceNeeded <= 0) {
      showToast('Bracket is already full!', 'info');
      return;
    }

    const availableRecommended = remainingTeams.filter((t) => t.recommended);
    const toAdd = (availableRecommended.length > 0 ? availableRecommended : remainingTeams).slice(0, spaceNeeded);

    if (toAdd.length === 0) {
      showToast('No remaining teams available to fill.', 'warning');
      return;
    }

    const addedIds = new Set(toAdd.map((t) => t.id));
    setRemainingTeams(remainingTeams.filter((t) => !addedIds.has(t.id)));
    setQualifiedTeams([...qualifiedTeams, ...toAdd]);
    showToast(`Auto-added ${toAdd.length} team(s) to bracket!`, 'success');
  };

  const handleReset = () => {
   setQualifiedTeams(qualifiedTeamsData?.data?.auto_qualified_teams || []);
      setRemainingTeams(qualifiedTeamsData?.data?.remaining_teams || []);
      setQualifierPerGroup(qualifiedTeamsData?.data?.min_advancing_per_group || 2);
      setFinalQualifier(qualifiedTeamsData?.data?.total_advancing_teams || 8);
      setRequiredCount(qualifiedTeamsData?.data?.total_advancing_teams || 8);
    showToast('Reset teams to original state.', 'info');
  };

  const filteredRemaining = remainingTeams.filter(
    (t) =>
      t.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      t.players.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleConfirmQualifiedTeams = async () => {
    console.log("hi");
    
    const QualifiedTeams = qualifiedTeams.map((item:any)=>item.id)
    const originalTeams = qualifiedTeamsData?.data?.auto_qualified_teams.map((item:any)=>item.id)
    const payload = {
         "event_id": id,
    "min_advancing_per_group":qualifierPerGroup ,
    "total_advancing_teams": finalQualifier,
    "extra_team_ids": QualifiedTeams.filter((item:any)=>!originalTeams.includes(item)),
    "excluded_team_ids":  originalTeams.filter((item:any)=>!QualifiedTeams.includes(item))
    }
    try {
      await toast.promise(
        confirmQualifiedTeams({ data: payload,booking_type: pageType }).unwrap(),
        toastMessage()
      );
      navigate(`/competitive/${pageType}s/KnockoutBracket/${id}`)
    } catch (error) {}
  };
  // Calculate empty drop slots needed
  const emptySlotsCount = Math.max(0, requiredCount - qualifiedTeams.length);

  return (
    <div className="max-h-[calc(100dvh-220px)] min-h-[calc(100dvh-240px)] overflow-auto customScroll">
      <div className="w-full mx-auto space-y-6">
        
        {}
        {notification && (
          <div
            className={`fixed top-4 right-4 z-50 flex items-center gap-2 px-4 py-3 rounded-xl shadow-lg border transition-all duration-300 animate-slide-down ${
              notification.type === 'success'
                ? 'bg-emerald-50 text-emerald-800 border-emerald-200'
                : notification.type === 'warning'
                ? 'bg-amber-50 text-amber-800 border-amber-200'
                : 'bg-blue-50 text-blue-800 border-blue-200'
            }`}
          >
            {notification.type === 'success' && <CheckCircle2 className="w-5 h-5 text-emerald-600" />}
            {notification.type === 'warning' && <AlertTriangle className="w-5 h-5 text-amber-600" />}
            {notification.type === 'info' && <Info className="w-5 h-5 text-blue-600" />}
            <span className="text-sm font-medium">{notification.message}</span>
            <button onClick={() => setNotification(null)} className="ml-2 text-slate-400 hover:text-slate-600">
              <X className="w-4 h-4" />
            </button>
          </div>
        )}

        
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 space-y-5">
          {/* Title and Pill Tag */}
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-extrabold text-[#1a233a] tracking-tight">
              Qualified Teams
            </h1>
            <div className={`px-4 py-1.5 rounded-full text-xs font-bold transition-colors ${
              qualifiedTeams.length === requiredCount 
                ? 'bg-emerald-100 text-emerald-700 border border-emerald-300' 
                : 'bg-[#FFF3F5] text-primaryRed border border-primaryRed'
            }`}>
              {qualifiedTeams.length}/{requiredCount} Selected
            </div>
          </div>

          {/* Alert Banner */}
          <div className="bg-[#FFCC8B1A] border border-[#DB881C] rounded-xl p-4 text-xs md:text-sm space-y-1">
            <div className="font-bold text-[#DB881C] flex items-center gap-2">
              <AlertTriangle className="w-4 h-4 inline shrink-0" />
              Action needed: Bracket needs exactly {requiredCount} qualified teams
            </div>
            <div className="text-[#DB881C] pl-6 font-medium">
              Qualified teams selected based on results System Nominates teams in the right box, <span className="font-bold underline">Please drag and drop your selection</span>
            </div>
          </div>

          {/* Stepper Controls and Action Buttons */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-end pt-2">
            {/* Qualifier per group */}
            <div className="lg:col-span-4 space-y-2">
              <label className="text-xs font-bold text-slate-600 tracking-wider">
                Qualifier per group
              </label>
              <div className="flex items-center gap-2">
                <button 
                //   onClick={() => setQualifierPerGroup(Math.max(1, qualifierPerGroup - 1))}
                  className="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition-colors font-bold"
                  aria-label="Decrease group qualifiers"
                >
                  <Minus className="w-4 h-4" />
                </button>
                <div className="flex-1 bg-white border border-slate-200 rounded-xl py-2.5 px-4 text-center font-bold text-slate-800 text-sm shadow-inner">
                  <span className="text-base text-slate-900 mr-1.5">{qualifierPerGroup}</span>
                  <span className="text-slate-400 font-normal">teams</span>
                </div>
                <button 
                //   onClick={() => setQualifierPerGroup(qualifierPerGroup + 1)}
                  className="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition-colors font-bold"
                  aria-label="Increase group qualifiers"
                >
                  <Plus className="w-4 h-4" />
                </button>
              </div>
            </div>

            {/* Final Qualifier */}
            <div className="lg:col-span-5 space-y-2">
              <label className="text-xs font-bold text-slate-600 tracking-wider">
                Final Qualifier
              </label>
              <div className="flex items-center gap-2">
                <button 
                //   onClick={() => setFinalQualifier(Math.max(4, finalQualifier - 2))}
                  className="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition-colors font-bold"
                  aria-label="Decrease final qualifiers"
                >
                  <Minus className="w-4 h-4" />
                </button>
                <div className="flex-1 bg-white border border-slate-200 rounded-xl py-2.5 px-4 text-center font-bold text-slate-800 text-sm shadow-inner">
                  <span className="text-base text-slate-900 mr-1.5">{finalQualifier}</span>
                  <span className="text-slate-400 font-normal">teams</span>
                </div>
                <button 
                //   onClick={() => setFinalQualifier(finalQualifier + 2)}
                  className="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition-colors font-bold"
                  aria-label="Increase final qualifiers"
                >
                  <Plus className="w-4 h-4" />
                </button>
              </div>
            </div>

            {/* Action Buttons: Edit and Apply */}
            <div className="lg:col-span-3 flex items-center justify-end gap-3 pt-2 lg:pt-0">
              <button 
              disabled
                onClick={() => setIsEditing(!isEditing)}
                className={`px-6 py-2.5 rounded-full font-bold text-xs transition-all border ${
                  isEditing 
                    ? 'border-indigo-600 text-indigo-600 hover:bg-indigo-50' 
                    : 'border-slate-300 text-slate-700 hover:bg-slate-50'
                }`}
              >
                {isEditing ? 'Editing' : 'Edit'}
              </button>
              <button 
               disabled
                onClick={() => showToast('Changes applied successfully!', 'success')}
                className="px-7 py-2.5 rounded-full bg-[#e8ebf0] hover:bg-[#d8dce5] active:scale-95 text-slate-700 font-bold text-xs transition-all shadow-sm"
              >
                Apply
              </button>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">

          {}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 space-y-4 min-h-[580px]">
            <div className="flex items-center justify-between">
              <div className="flex items-start gap-2">
                <h2 className="text-xl font-extrabold text-[#1a233a]">
                  Qualified Teams
                </h2>
                <span className="text-xl font-extrabold text-slate-400">
                  {qualifiedTeams.length}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={handleReset}
                  className="text-xs text-slate-400 hover:text-slate-600 flex items-center gap-1 font-medium px-2 py-1 rounded hover:bg-slate-100 transition-colors"
                  title="Reset teams"
                >
                  <RotateCcw className="w-3.5 h-3.5" />
                  Reset
                </button>
              </div>
            </div>

            {/* Qualified Teams Grid */}
            <div 
              className="grid grid-cols-1 sm:grid-cols-2 gap-3"
              onDragOver={handleDragOver}
              onDrop={(e) => handleDropToQualified(e)}
            >
              {qualifiedTeams.map((team, index) => (
                <div
                  key={team.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, team, 'qualified')}
                  className="relative group bg-white border-2 border-[#5c87e5] rounded-2xl p-3.5 shadow-sm hover:shadow-md transition-all duration-200 cursor-grab active:cursor-grabbing"
                >
                  {/* Top Header Row inside Card */}
                  <div className="flex items-start gap-2.5 mb-2">
                    <div className="w-7 h-7 rounded-full bg-[#f0f4fd] text-[#3366cc] font-bold text-xs flex items-center justify-center shrink-0 mt-0.5">
                      {index + 1}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <h3 className="font-bold text-slate-900 text-sm truncate">
                          {team.name}
                        </h3>
                        <button
                          onClick={() => removeFromQualified(team)}
                          className="opacity-0 group-hover:opacity-100 text-slate-300 hover:text-red-500 transition-opacity p-0.5"
                          title="Remove team"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                      <p className="text-[11px] text-slate-400 truncate font-medium">
                        {team.players}
                      </p>
                    </div>
                  </div>

                  {/* Points Badge */}
                  <div className="mb-2.5">
                    <span className="inline-block bg-[#ebf2ff] text-[#2c62d6] font-extrabold text-[11px] px-3 py-1 rounded-full">
                      {team.points} Points
                    </span>
                  </div>

                  {/* Stats Pill Row */}
                  <div className="flex items-center gap-1 text-[11px] font-semibold">
                    <span className="bg-[#f2f6fd] text-slate-600 px-2 py-0.5 rounded-md">W: {team.stats.w}</span>
                    <span className="bg-[#f2f6fd] text-slate-600 px-2 py-0.5 rounded-md">L: {team.stats.l}</span>
                    <span className="bg-[#f2f6fd] text-slate-600 px-2 py-0.5 rounded-md">T: {team.stats.t}</span>
                    <span className="bg-[#f2f6fd] text-slate-600 px-2 py-0.5 rounded-md">PF: {team.stats.pf}</span>
                    <span className="bg-[#f2f6fd] text-slate-600 px-2 py-0.5 rounded-md">PA: {team.stats.pa}</span>
                  </div>
                </div>
              ))}

              {/* Dynamic Empty Drop slots */}
              {Array.from({ length: Math.max(1, emptySlotsCount) }).map((_, idx) => (
                <div
                  key={`empty-${idx}`}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDropToQualified(e, qualifiedTeams.length + idx)}
                  className="border-2 border-dashed border-slate-200 rounded-2xl min-h-[128px] flex items-center justify-center p-4 hover:border-blue-400 hover:bg-blue-50/20 transition-all cursor-pointer text-slate-400 group"
                  onClick={autoFillRecommended}
                >
                  <div className="text-center space-y-1">
                    <p className="text-xs font-semibold text-slate-400 group-hover:text-blue-600 transition-colors">
                      Drop here
                    </p>
                    <p className="text-[10px] text-slate-300 group-hover:text-blue-400">
                      or click to auto-fill
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {}
          <div 
            className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 space-y-4 min-h-[580px] relative"
            onDragOver={handleDragOver}
            onDrop={handleDropToRemaining}
          >
            {/* Top Toolbar */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div className="flex items-start gap-2">
                <h2 className="text-xl font-extrabold text-[#1a233a]">
                  Remaining Teams
                </h2>
                <span className="text-xl font-extrabold text-slate-400">
                  {remainingTeams.length}
                </span>
              </div>

              {/* Search & Auto-fill Action */}
              <div className="flex items-center gap-2">
                <div className="relative">
                  <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search teams..."
                    className="pl-8 pr-3 py-1 rounded-lg border border-slate-200 text-xs text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 w-32 sm:w-40"
                  />
                </div>
                <button
                  onClick={autoFillRecommended}
                  className="bg-emerald-50 hover:bg-emerald-100 text-emerald-700 text-xs font-bold px-3 py-1.5 rounded-lg border border-emerald-200 transition-colors flex items-center gap-1.5 shrink-0"
                >
                  
                  Auto-fill
                </button>
              </div>
            </div>

            {/* Remaining Teams Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              {filteredRemaining.map((team, index) => {
                const isFirstRecommended = index === 0 && team.recommended;

                return (
                  <div key={team.id} className="relative">
                    {/* "Drag here" Tooltip Callout on top of first recommended team */}
                    {isFirstRecommended && (
                      <div className="absolute -top-7 left-1/2 -translate-x-1/2 z-20 animate-bounce">
                        <div className="bg-[#b3e600] text-slate-900 font-extrabold text-[11px] px-3 py-1 rounded-md shadow-md flex items-center gap-1 relative">
                          Drag here
                          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-[#b3e600] rotate-45"></div>
                        </div>
                      </div>
                    )}

                    {/* Team Card */}
                    <div
                      draggable
                      onDragStart={(e) => handleDragStart(e, team, 'remaining')}
                      onClick={() => moveToQualified(team)}
                      className={`relative bg-[#f8fafc] border-2 ${
                        team.recommended 
                          ? 'border-dashed border-[#00cc66] bg-[#f4fbf7]' 
                          : 'border-dashed border-slate-200 hover:border-slate-300'
                      } rounded-2xl p-3.5 shadow-xs hover:shadow-md transition-all duration-200 cursor-grab active:cursor-grabbing group`}
                    >
                      {/* Top Row: Index, Name, Handle Icon */}
                      <div className="flex items-start gap-2.5 mb-2">
                        <div className="w-7 h-7 rounded-full bg-slate-200 text-slate-700 font-bold text-xs flex items-center justify-center shrink-0 mt-0.5">
                          {team.seed}
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-slate-800 text-sm truncate">
                            {team.name}
                          </h3>
                          <p className="text-[11px] text-slate-400 truncate font-medium">
                            {team.players}
                          </p>
                        </div>
                        <GripVertical className="w-4 h-4 text-slate-300 group-hover:text-slate-500 transition-colors shrink-0" />
                      </div>

                      {/* Points Tag & Recommended Tag */}
                      <div className="flex items-center justify-between gap-2 mb-2.5">
                        <span className="inline-block bg-[#eef2f8] text-[#334155] font-extrabold text-[11px] px-3 py-1 rounded-full">
                          {team.points} Points
                        </span>
                        {team.recommended && (
                          <span className="bg-[#e6f9f0] text-[#00a352] text-[10px] font-bold px-2.5 py-0.5 rounded-full border border-[#b8f2d5]">
                            Recommended
                          </span>
                        )}
                      </div>

                      {/* Stats Row */}
                      <div className="flex items-center gap-1 text-[11px] font-semibold">
                        <span className="bg-white text-slate-600 px-2 py-0.5 rounded-md border border-slate-100">W: {team.stats.w}</span>
                        <span className="bg-white text-slate-600 px-2 py-0.5 rounded-md border border-slate-100">L: {team.stats.l}</span>
                        <span className="bg-white text-slate-600 px-2 py-0.5 rounded-md border border-slate-100">T: {team.stats.t}</span>
                        <span className="bg-white text-slate-600 px-2 py-0.5 rounded-md border border-slate-100">PF: {team.stats.pf}</span>
                        <span className="bg-white text-slate-600 px-2 py-0.5 rounded-md border border-slate-100">PA: {team.stats.pa}</span>
                      </div>
                    </div>
                  </div>
                );
              })}

              {filteredRemaining.length === 0 && (
                <div className="col-span-2 text-center py-12 text-slate-400 text-sm">
                  No remaining teams match your query.
                </div>
              )}
            </div>
          </div>
        </div>

        {}
       <div className='w-full bg-white p-5 flex justify-between items-center '>
         <Button customeStyle=' flex  items-center justify-center border border-primary rounded-full w-full text-[16px] font-bold py-5 gap-4' text={""} width='min-w-[150px]' onClick={()=>{
            navigate(`/competitive/${pageType}s/rounds/${id}?page=groups`)
         }} >
            <ChevronLeft/>
            Back
          </Button>
          <div className='flex gap-7 items-center'>
            {qualifiedTeams.length < finalQualifier &&<p className='text-primaryRed bg-[#FFF3F5] py-2 px-4 font-bold flex gap-2 items-center'><Info size={18}/> pending teams selection</p>}
           <Button customeStyle={cn(' flex  items-center justify-center bg-primary text-primaryYellow rounded-full w-full text-[16px] font-bold py-5 gap-4',qualifiedTeams.length < finalQualifier && 'cursor-not-allowed bg-[#F5F6F7] text-[#A4A3BA]')} text={""} width='min-w-[150px]' onClick={async ()=>{
            if(qualifiedTeams.length < finalQualifier) return
            await handleConfirmQualifiedTeams()
            }}>
            Next
            <ChevronRight/>
            
          </Button>
          </div>
       </div>
         
      </div>
    </div>
  );
}